<template>
  <div class="section-category section-full">
    <div id="shift-report-printable-area" class="section-cashcalc endday px-2" v-if="summary">
      <h2 class="ttl2 popup-header">{{ $gettext('Day report') }} - {{ summary.startTime }} </h2>
      <div class="text-center">{{ $gettext('Location') }}: <b>{{ summary.location.name }}</b></div>

      <!-- Block day report  -->
      <div>
        <table class="table table-border-outline">
          <thead class="thead-light">
            <tr>
              <th v-translate class="text-left">Shift#Staff</th>
              <th v-translate>Start</th>
              <th v-translate>End</th>
              <th><span v-translate>Amount</span> ({{ getMap('currency').symbol }})</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(shift, i) in summary.shifts" :key="i" class="border-bottom" >
              <td class="text-left"> {{ shift.name }} </td>
              <td>{{ shift.start }}</td>
              <td>{{ shift.end }}</td>
              <td>{{ shift.amount | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Block shift report  -->
      <div class="row">
        <div class="col-md-6 pr-md-0">
          <table class="table table-border-outline">
            <thead class="thead-light">
            <tr class="text-uppercase">
              <th
                class="text-left"
                v-translate
                style="width: 200px;"
              >bill status</th>
              <th v-translate>amount</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-left"><span v-translate>Close</span> ({{ summary.bills[1].count }})</td>
              <td>{{ summary.bills[1].amount | currency }}</td>
            </tr>
            <tr class="border-bottom">
              <td class="text-left"> <span v-translate>Void</span> ({{ summary.bills[2].count }})</td>
              <td>{{ summary.bills[2].amount | currency }}</td>
            </tr>
            <tr class="border-bottom">
              <td class="text-left">
                <span v-translate>Open</span> ({{ summary.bills[0].count }})
              </td>
              <td>{{ summary.bills[0].amount | currency }}</td>
            </tr>
            </tbody>
          </table>
          <table class="table table-border-outline do-payment-table" style="table-layout: auto;">
            <thead class="thead-light">
              <tr class="text-uppercase">
                <th class="text-left" v-translate>tax / charges</th>
                <th v-translate>amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, charge) in summary.chargeData" >
                <td>{{ charge }}</td>
                <td>{{ value | currency(true) }}</td>
              </tr>
            </tbody>
          </table>
          <table class="table table-border-outline do-payment-table" style="table-layout: auto;">
            <thead class="thead-light">
              <tr class="text-uppercase">
                <th class="text-left" v-translate>do payment</th>
                <th v-translate>amount</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(group, groupIndex) in tablePayment">
                <tr @click="group.open = !group.open" :class="{ opened: group.open == true }" class="tr-parent">
                  <td>
                    <span class="icon-expanded"></span>
                    <span>{{ group.name }} ({{ group.payments.length }})</span>
                  </td>
                  <td>{{ group.total | currency }}</td>
                </tr>
                <tr v-show="group.open" v-for="(payment, paymentIndex) in group.payments" class="tr-child">
                  <template>
                    <td >{{ payment.expenseCategoryName }} - {{ payment.note }}</td>
                    <td>{{ payment.amount | currency }}</td>
                  </template>
                </tr>
              </template>
            </tbody>
          </table>
          <table class="table table-border-outline do-payment-table" style="table-layout: auto;">
            <thead class="thead-light">
              <tr class="text-uppercase">
                <th class="text-left" v-translate>Commission</th>
                <th v-translate>amount</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="commission in tableCommission">
                <tr @click="commission.open = !commission.open" :class="{ opened: commission.open == true }" class="tr-parent">
                  <td>
                    <span class="icon-expanded"></span>
                    <span>{{ commission.name }} ({{ commission.payments.length }})</span>
                  </td>
                  <td>{{ commission.total | currency(true) }}</td>
                </tr>
                <tr v-show="commission.open" v-for="com in commission.payments" class="tr-child">
                  <template>
                    <td ><translate>Staff</translate> #{{ com.note }}</td>
                    <td>{{ com.amount | currency(true) }}</td>
                  </template>
                </tr>
              </template>
            </tbody>
          </table>
          <table class="table table-border-outline do-payment-table" style="table-layout: auto;">
            <thead class="thead-light">
              <tr class="text-uppercase">
                <th class="text-left" v-translate>discount</th>
                <th v-translate>amount</th>
              </tr>
            </thead>
            <tbody>
              <tr class="tr-parent">
                <td>
                  <span v-translate>Credited back line value</span>
                </td>
                <td>{{ summary.overall['Credited back line value'] | currency(true) }}</td>
              </tr>
              <tr class="tr-parent">
                <td>
                  <span v-translate>Promotions value (discount value)</span>
                </td>
                <td>{{ summary.overall['Promotion(discount) value'] | currency(true) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-6">
          <table class="table table-border-outline">
            <thead class="thead-light">
            <tr class="text-uppercase">
              <th
                class="text-left"
                v-translate
                style="width: 200px;"
              >customer payment</th>
              <th v-translate>amount</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-left"><span v-translate>Cash</span></td>
              <td>{{ summary.bills[1].cash | currency }}</td>
            </tr>
            <tr class="border-bottom" v-for="(amount,payTypeName) in summary.bills[1]['cardAndOther']">
              <td class="text-left"> <span >{{ payTypeName }}</span></td>
              <td>{{ amount | currency }}</td>
            </tr>

            </tbody>
          </table>
          <table class="table table-shift-report">
            <tbody>
              <tr>
                <td v-translate>Sales result</td>
                <td>{{ summary.bills[1].amount | currency }}</td>
              </tr>
              <tr>
                <td v-translate>Payments (money-in)</td>
                <td>{{ summary.overall['Payments(money-in)'] | currency }}</td>
              </tr>
              <tr>
                <td v-translate>Payments (money-out)</td>
                <td>{{ summary.overall['Payments(money-out)'] | currency }}</td>
              </tr>
              <tr>
                <td v-translate>Commissions Paid</td>
                <td>{{ summary.overall['Commission paid'] | currency(true) }}</td>
              </tr>

              <tr class="bg-hightlight">
                <td v-translate>Total for day</td>
                <td>{{ summary.overall['Total day'] | currency }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="btns-footer">
      <button class="btn btn-btn" @click="handleConfirm" v-translate>print</button>
    </div>
    <MonthReport ref="monthReport"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DayService from '@/services/DayService';
import ShiftService from '@/services/ShiftService';
import {
  UPDATE_SHIFT, SET_SHIFT_CURRENT_ACTION, SET_MESSAGE_MODAL, SET_CONFIRM_MODAL,
} from '@/store/mutation-types';
import MonthReport from '@/components/MonthReport';

export default {
  name: 'EndOfDay',
  components: {
    MonthReport,
  },
  data() {
    return {
      summary: null,
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      bill: state => state.bill,
      workDay: state => state.auth.user.workDay,
    }),
  },
  methods: {
    handleConfirm() {
      this.$store.commit(SET_CONFIRM_MODAL, {
        action: this.$gettext('end work day'),
        context: this,
        func: this.endDay,
      });
    },
    async endDay() {
      const report = await this.$store.dispatch(
        'createPdf',
        {
          element: document
            .getElementById('shift-report-printable-area'),
          reportType: 'workDay',
          startTime: this.user.workDay.startTime,
        },
      );

      const data = await DayService.endDay({
                              pdf: report.file,
                              message: report.message,
                              fileName: report.name
                            });

      if(data) {
        if(data['error']) {
          if(data['error'] == 'The optimistic lock on an entity failed.') {
            this.$store.commit(SET_MESSAGE_MODAL, 'An end of day operation is running.');
            return;
          }
          this.$store.commit(SET_MESSAGE_MODAL, data['error']);
          return;
        }
        await this.$store.dispatch('print', data);
        await report.pdf.save(report.name, { returnPromise: true });
        await this.$refs.monthReport.getMonthReport();
        this.$store.state.auth.user.workDay = null;
        localStorage.setItem('pos_user', JSON.stringify(this.$store.state.auth.user));
        this.$router.push({name: 'order'});
        const self = this;
        setTimeout(function() {
          self.$store.dispatch('logout');
        }, 180000);
      }
    },
  },
  async created() {
    if(!this.user.workDay) this.$router.push({ name: 'order' });
    const response = await DayService.infoDay();
    if (response) {
      this.summary = response;
      this.tablePayment = [
        {
          name: this.$gettext('Money-in'),
          payments: this.summary.moneyIns,
          total: this.summary.moneyIns.reduce((sum, payment) => sum + payment.amount, 0),
          open: true
        },
        {
          name: this.$gettext('Money-out'),
          payments: this.summary.moneyOuts,
          total: this.summary.moneyOuts.reduce((sum, payment) => sum + payment.amount, 0),
          open: true
        },
      ];
      this.tableCommission = [
        {
          name: this.$gettext('Earned Commission'),
          payments: this.summary.commissionList,
          total: this.summary.commissionList.reduce((sum, payment) => sum + payment.amount, 0),
          open: true
        },
        {
          name: this.$gettext('Paid Commission'),
          payments: this.summary.payCommissions,
          total: this.summary.payCommissions.reduce((sum, payment) => sum + payment.amount, 0),
          open: true
        },
      ];
    }
  },
};
</script>

<style scoped>
tr.border-top.border-bottom td {
  color: #F00;
}
</style>
